import { Paragraph } from 'docx';
import { EsrsReportStandard } from '../../Report.types';
import { TextStyle } from '../reportThemes';
import { createDisclosures } from './disclosure-requirements';
import { FrameworkRefs } from 'containers/Esrs';

export const createStandards = (
  standards: EsrsReportStandard[],
  companyCurrency: string,
  year: number,
  framework: string
) => {
  const visibleStandards = standards.filter(
    (standard) =>
      !standard.disclosureRequirements.every(
        (dr) => dr.isHidden || dr.metrics.every((metric) => metric.metric.isHidden)
      )
  );

  const displayedStandards = visibleStandards.flatMap((standard) => {
    return [
      new Paragraph({
        text: `${framework !== FrameworkRefs.vsme ? standard.reference.replace(/-/g, ' ') : ''} ${standard.title}`,
        style: TextStyle.h1,
        spacing: {
          after: 200,
        },
      }),
      createDisclosures(
        standard.disclosureRequirements,
        companyCurrency,
        standard.targetQuestions,
        standard.actionQuestions,
        standard.reference,
        year,
        framework
      ),
    ];
  });
  return displayedStandards.flat();
};
